module.exports = __webpack_public_path__ + "media/images/new_home/story-edwards-family-375946155bd588150cb523829a1ef42c.jpg";